import {
  ID__ATS_TYPE__ASHBY_API,
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__GH_INGESTION,
  ID__ATS_TYPE__LEVER_API,
  ID__ATS_TYPE__NONE
} from '../../Definition';

export const MODEL__ATS__EMPLOYER__GREENHOUSE_HARVEST = {
  apiName: 'Greenhouse Harvest', // Constant
  apiKey: '', // Required
  manualSubmissionUrl: '', // Optional
  onBehalfOfEmployerUserId: null, // Required (validated by connection)
  onBehalfOfEmployerUserName: '', // Required (calculated from user id)
  sourceIdAgencyId: null, // Required (validated by connection)
  agencyName: '', // Required (calculated from source id)
  agencyRecruiterName: ''
};

export const MODEL__ATS__EMPLOYER__GREENHOUSE_INGESTION = {
  apiName: 'Greenhouse Ingestion', // Constant
  apiKey: '', // Required
  manualSubmissionUrl: '', // Optional
  onBehalfOfEmployerUser: '', // Optional (non-validated)
};

export const MODEL__ATS__EMPLOYER__LEVER_API = {
  apiName: 'Lever', // Constant
  manualSubmissionUrl: '', // Optional
  userId: '', // Required (validated by oauth)
  agencyName: '', // Required (validated by oauth)
};

export const MODEL__ATS__EMPLOYER__ASHBY = {
  apiName: 'Ashby', // Constant
  apiKey: '', // Required
  manualSubmissionUrl: '', // Optional
  sourceId: '', // Required
  userEmail: '', // Constant (recruiter@10by10.io)
  userId: '', // Required (calculated from email address)
  userName: '', // Optional (calculated from email address)
  userGlobalRole: '', // Optional (calculated from email address)
};

export const DIC__ATS__MODELS = {
  'Employer': {
    [ID__ATS_TYPE__GH_HARVEST]: MODEL__ATS__EMPLOYER__GREENHOUSE_HARVEST,
    [ID__ATS_TYPE__GH_INGESTION]: MODEL__ATS__EMPLOYER__GREENHOUSE_INGESTION,
    [ID__ATS_TYPE__LEVER_API]: MODEL__ATS__EMPLOYER__LEVER_API,
    [ID__ATS_TYPE__ASHBY_API]: MODEL__ATS__EMPLOYER__ASHBY
  },
  'Job': {
    // Common
    [ID__ATS_TYPE__NONE]: {
      jobId: ''
    },
    [ID__ATS_TYPE__LEVER_API]: {
      postId: ''
    }
  }
};